module.exports = __webpack_public_path__ + "img/person.5d9f0a4e.svg";